(() => {
  const normalize = (value) => value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLocaleLowerCase()
    .trim();

  document.querySelectorAll('[data-crystal-index]').forEach((index) => {
    const form = index.querySelector('[data-crystal-search-form]');
    const input = index.querySelector('[data-crystal-search]');
    const reset = index.querySelector('[data-crystal-search-reset]');
    const emptyReset = index.querySelector('[data-crystal-empty-reset]');
    const status = index.querySelector('[data-crystal-search-status]');
    const empty = index.querySelector('[data-crystal-empty]');
    const items = Array.from(index.querySelectorAll('[data-crystal-item]'));
    const directory = index.querySelector('[data-crystal-directory]');
    index.querySelector('[data-crystal-suggestions]')?.removeAttribute('hidden');
    const families = Array.from(index.querySelectorAll('[data-crystal-family]'));

    if (!form || !input || !status || items.length === 0) return;

    const singular = index.dataset.resultSingular || 'stone';
    const plural = index.dataset.resultPlural || 'stones';
    const noResults = index.dataset.noResults || 'No matching stones';

    const updateUrl = (query) => {
      if (!window.history?.replaceState) return;
      const url = new URL(window.location.href);
      if (query) url.searchParams.set('crystal_q', query);
      else url.searchParams.delete('crystal_q');
      window.history.replaceState(window.history.state, '', url);
    };

    const filter = ({ updateHistory = true } = {}) => {
      const rawQuery = input.value.trim();
      const query = normalize(rawQuery);
      let visibleCount = 0;

      items.forEach((item) => {
        const haystack = normalize(item.dataset.searchTerms || item.textContent || '');
        const matches = !query || query.split(/\s+/).every((term) => haystack.includes(term));
        item.hidden = !matches;
        if (matches) visibleCount += 1;
      });

      families.forEach((family) => {
        const hasVisibleItem = family.querySelector('[data-crystal-item]:not([hidden])');
        family.hidden = !hasVisibleItem;
      });

      if (reset) reset.hidden = !rawQuery;
      if (empty) empty.hidden = visibleCount !== 0;
      status.textContent = visibleCount === 0
        ? noResults
        : `${visibleCount} ${visibleCount === 1 ? singular : plural}`;

      if (updateHistory) updateUrl(rawQuery);
    };

    const clear = () => {
      input.value = '';
      filter();
      input.focus();
    };

    const showResults = () => {
      filter();
      directory?.focus({ preventScroll: true });
      directory?.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
    };
    form.addEventListener('submit', (event) => { event.preventDefault(); showResults(); });
    index.querySelectorAll('[data-crystal-query]').forEach((button) => button.addEventListener('click', () => {
      input.value = button.dataset.crystalQuery;
      showResults();
    }));
    index.querySelectorAll('[data-crystal-family-link]').forEach((link) => link.addEventListener('click', () => {
      if (input.value) { input.value = ''; filter(); }
    }));
    window.addEventListener('popstate', () => {
      input.value = new URL(window.location.href).searchParams.get('crystal_q') || '';
      filter({ updateHistory: false });
    });
    input.addEventListener('input', () => filter());
    input.addEventListener('search', () => filter());
    reset?.addEventListener('click', clear);
    emptyReset?.addEventListener('click', clear);

    const initialQuery = new URL(window.location.href).searchParams.get('crystal_q');
    if (initialQuery) {
      input.value = initialQuery;
      filter({ updateHistory: false });
    } else {
      filter({ updateHistory: false });
    }
  });
})();
